import { render, staticRenderFns } from "./ResourcesResults.vue?vue&type=template&id=f60b4e0c&scoped=true&"
import script from "./ResourcesResults.vue?vue&type=script&lang=js&"
export * from "./ResourcesResults.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesResults.vue?vue&type=style&index=0&id=f60b4e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f60b4e0c",
  null
  
)

export default component.exports